import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class portfolioListSlider {
  constructor() {
    this.sliderDocumentContainerSelector = 'portfolio__list';
    this.slideDocumentSelector = 'portfolio__item';

    this.pagination = {
      el: '.portfolio__list__pagination',
      lockClass: 'portfolio__list__pagination_disable',
      clickable: true,
    };

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    const sliderDocument = document.querySelector(`.${this.sliderDocumentContainerSelector}`);
    const { pagination } = this;
    if (!sliderDocument) return;

    this.blogSlider = new Swiper(`.${this.sliderDocumentContainerSelector}`, {
      slidesPerView: 1.5,
      slidesPerColumn: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      pagination,
      breakpoints: {
        768: {
          slidesPerColumn: 3,
          slidesPerGroup: 3,
          slidesPerView: 2,
        },
        1200: {
          slidesPerColumn: 3,
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
      },
    });
  }
}();
